egtoUniqueValidation.$inject = ['$q'];

export function egtoUniqueValidation($q) {
    var directive = {
        require: 'ngModel',
        link: link,
        restrict: 'A',
        scope: {
            egtoUniqueValidation: '=egtoUniqueValidation'
        }
    };
    return directive;

    function link($scope, element, attrs, ngModel) {
        var validation = $scope.egtoUniqueValidation;
        ngModel.$asyncValidators.uniqueName = uniqueName;

        //////////////////////

        function uniqueName(modelValue, viewValue) {
            var deferred = $q.defer();
            validation.requestCallback(viewValue).then(success, error);
            return deferred.promise;

            function success(identifiable) {
                if (!identifiable.id) {
                    deferred.resolve();
                    return;
                }

                if (identifiable.id === validation.currentValue.id) {
                    deferred.resolve();
                    return;
                }

                deferred.reject('Value not unique');
            }

            function error() {
                deferred.reject('server side error');
            }
        }
    }
}